<template>
  <div class="q-img-container main-color">
    <v-runtime-template :template="question.q" />
     <div class="image-panel" align="center">
      <img :src="question.path" alt="Imagen">
    </div>
  </div>
</template>

<script>

import VRuntimeTemplate from "v-runtime-template";
export default {
  name: "image-question",
  components: {
    VRuntimeTemplate
  },
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      },
      surveyIdProp:{
        type: String,
        default: "test"
      }
    }
  },
  data: function() {
    return {
      answer: "",
      resultId: "",
      urlComentarios: ""
    };
  },
  mounted: function() {
    this.resultId = this.$route.query.r;
  }
};
</script>
